module.exports = __webpack_public_path__ + "static/img/planet_hover.47906908.png";